/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";
import thsLogo from "assets/img/logo_ths.webp";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";

const useStyles = makeStyles(styles);

const sectionLabel = {
  padding: "18px 22px 10px",
  fontSize: "10px",
  fontWeight: "700",
  color: "rgba(255,255,255,0.42)",
  textTransform: "uppercase",
  letterSpacing: "1.2px",
};

export default function Sidebar(props) {
  const classes = useStyles();
  let location = useLocation();

  function activeRoute(routeName) {
    return location.pathname === routeName;
  }

  const { color, routes, userdetails } = props;

  var links = (
    <List className={classes.list}>
      <div style={sectionLabel}>Main Menu</div>
      {routes.map((prop, key) => {
        var activePro = " ";
        var listItemClasses;
        if (prop.path === "/upgrade-to-pro") {
          activePro = classes.activePro + " ";
          listItemClasses = classNames({ [" " + classes[color]]: true });
        } else {
          listItemClasses = classNames({
            [" " + classes[color]]: activeRoute(prop.layout + prop.path),
          });
        }
        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path),
        });
        const isActive = activeRoute(prop.layout + prop.path);
        return (
          <NavLink
            to={{
              pathname: prop.layout + prop.path,
              aboutProps: { name: userdetails },
            }}
            className={activePro + classes.item}
            activeClassName="active"
            key={key}
          >
            <ListItem button className={classes.itemLink + listItemClasses}>
              {typeof prop.icon === "string" ? (
                <Icon
                  className={classNames(classes.itemIcon, whiteFontClasses)}
                  style={isActive ? { color: "#2f72f2" } : {}}
                >
                  {prop.icon}
                </Icon>
              ) : (
                <prop.icon
                  className={classNames(classes.itemIcon, whiteFontClasses)}
                  style={isActive ? { color: "#2f72f2" } : {}}
                  weight="duotone"
                />
              )}
              <ListItemText
                primary={props.rtlActive ? prop.rtlName : prop.name}
                className={classNames(classes.itemText, whiteFontClasses)}
                disableTypography={true}
                style={
                  isActive ? { color: "#2f72f2", fontWeight: "700" } : {}
                }
              />
              {isActive && (
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    background: "#2f72f2",
                    flexShrink: 0,
                  }}
                />
              )}
            </ListItem>
          </NavLink>
        );
      })}
    </List>
  );

  // ── Brand / Logo ──────────────────────────────────────────
  var brand = (
    <div className={classes.logo}>
      <a href="/" className={classes.logoLink}>
        <div
          className={classes.logoImage}
          style={{
            background: "rgba(255,255,255,0.18)",
            border: "1.5px solid rgba(255,255,255,0.3)",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "40px",
            height: "40px",
            flexShrink: 0,
          }}
        >
          <img
            src={thsLogo}
            alt="Telemed Healthcare Solutions"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              filter: "brightness(0) invert(1)",
            }}
          />
        </div>

        {/* Brand text */}
        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.25 }}>
          <span
            style={{
              fontFamily: '"Inter", sans-serif',
              fontWeight: 700,
              fontSize: "15px",
              color: "#ffffff",
              letterSpacing: "-0.2px",
            }}
          >
            THS Billing
          </span>
          <span
            style={{
              fontFamily: '"Inter", sans-serif',
              fontWeight: 400,
              fontSize: "10px",
              color: "rgba(255,255,255,0.55)",
              letterSpacing: "0.3px",
            }}
          >
            Telemed Healthcare
          </span>
        </div>
      </a>
    </div>
  );

  // ── User footer ───────────────────────────────────────────
  const userInitial =
    userdetails && userdetails.Name
      ? userdetails.Name.charAt(0).toUpperCase()
      : "A";
  const userName =
    userdetails && userdetails.Name ? userdetails.Name : "Admin User";
  const userRole =
    userdetails && userdetails.Usertype
      ? userdetails.Usertype
      : "Administrator";

  const userFooter = (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        padding: "14px 16px",
        borderTop: "1px solid rgba(255,255,255,0.14)",
        background: "rgba(0,0,0,0.12)",
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #ffffff 0%, #e8f0fe 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#2f72f2",
          fontWeight: "700",
          fontSize: "15px",
          flexShrink: 0,
          border: "2px solid rgba(255,255,255,0.3)",
        }}
      >
        {userInitial}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: "12.5px",
            fontWeight: "600",
            color: "#ffffff",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {userName}
        </div>
        <div style={{ fontSize: "10.5px", color: "rgba(255,255,255,0.55)" }}>
          {userRole}
        </div>
      </div>
      {/* Online indicator */}
      <div
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          background: "#34d399",
          flexShrink: 0,
          boxShadow: "0 0 0 3px rgba(52,211,153,0.25)",
        }}
      />
    </div>
  );

  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
            {links}
          </div>
          {userFooter}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {userFooter}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool,
};
